import { render, staticRenderFns } from "./bomsku.vue?vue&type=template&id=480235d7"
import script from "./bomsku.vue?vue&type=script&lang=js"
export * from "./bomsku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports